import { useState } from 'react';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';

import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import BasicsSection from 'src/paginas/gestao-risco/processo/search-drawer/components/sections/BasicsSection';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

const ProcessoSearch = ({ model, configuracao, searchSchema, showModal }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  const fields = searchSchema?.fields || {};

  const hasField = (fieldName) => Boolean(fields[fieldName]);

  const showCustomFields = hasField('camposCustomizados') && !showModal;

  return (
    <div>
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <BasicsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
        fields={fields}
      />

      {showCustomFields && (
        <CustomFieldsSection
          model={model}
          intl={intl}
          searchQuery={searchQuery}
        />
      )}
    </div>
  );
};

export default ProcessoSearch;
